/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import useFooterSubscriptionFields from './useFooterSubscriptionFields'
import Field from '../field'

const FooterSubscriptionFields = ({form, prefix = ''}) => {
    const fields = useFooterSubscriptionFields({form, prefix})
    const styles = useStyleConfig('FormStyles')
    return (
        <Stack {...styles.fieldsStack}>
            <Field
                {...fields.email}
                eventAction="subscription-form"
                eventLabel="Email Address*"
                triggerGtm={false}
            />
            <Field
                {...fields.zipCode}
                eventAction="subscription-form"
                eventLabel="Zip Code*"
                triggerGtm={false}
            />
        </Stack>
    )
}

FooterSubscriptionFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default FooterSubscriptionFields
